'use strict';

angular
  .module('ClinicApp')
  .directive('embeddedSvg', () => ({
    restrict: 'E',
    scope: {
      path: '@',
    },
    link: ($scope, $element) => {
      const loadSvg = async () => {
        const res = await fetch($scope.path);
        const svg = await res.text();

        $element.html(svg);
      };

      loadSvg();
    },
  }));
